import { useDispatch, useSelector } from "react-redux";
import { apiSlice } from "../../features/api/apiSlice";
import { featuredToggled } from "../../features/api/filterSlice";

export default function Filter({setBooksData}) {
  const selectBook = apiSlice.endpoints.getBooks.select();
 const dispacth = useDispatch()

  const {isFeatured} = useSelector(state=>state.filter)

  return (
    <div className="flex items-center space-x-4">
      <button onClick={()=> dispacth(featuredToggled(false)) } className={`lws-filter-btn ${isFeatured ? '': 'active-filter'}`}>All</button>
      <button onClick={()=> dispacth(featuredToggled(true)) } className={`lws-filter-btn ${!isFeatured ? '': 'active-filter'}`}>Featured</button>
    </div>
  )
}